import i18n from "../i18n";

export const getIntlLocale = (): string => (i18n.language?.startsWith("es") ? "es" : "en-US");
